import { createSlice } from "@reduxjs/toolkit";

const initialState = {};
const MasterReducer = createSlice({
  name: "Master",
  initialState,
  reducers: {
    defaultAction: (state, { payload }) => {
      console.log("MasterReducer state and payload", state, payload);
    },
  },
});

const { reducer, actions } = MasterReducer;
export const { defaultAction } = actions;
export default reducer;
